import { render, staticRenderFns } from "./ProgressChart.vue?vue&type=template&id=2b20d034&scoped=true&lang=html"
import script from "./ProgressChart.vue?vue&type=script&lang=js"
export * from "./ProgressChart.vue?vue&type=script&lang=js"
import style0 from "./ProgressChart.vue?vue&type=style&index=0&id=2b20d034&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b20d034",
  null
  
)

export default component.exports